import React from 'react';
import './Authorize.sass';

import {connect} from 'react-redux';

import hoistNonReactStatics from 'hoist-non-react-statics';

import AuthFlowModal from './modals/AuthFlowModal';

export default WrappedComponent => {
  const Authorize = ({token, ...rest}) => token ? (
    <WrappedComponent {...rest}/>
  ) : (
    <div className="page-auth">
      <AuthFlowModal page/>
    </div>
  );

  hoistNonReactStatics(Authorize, WrappedComponent);

  Authorize.WrappedComponent = WrappedComponent;
  Authorize.displayName = `Authorize(${WrappedComponent.displayName})`;

  return connect(({auth}) => ({token: auth.token}), {})(Authorize);
}



// WEBPACK FOOTER //
// ./containers/auth/Authorize.js